import React from 'react'
import { BuyingSessionSidebarContext } from './buyingSession-sidebar-context'

export const useBuyingSessionSidebarContext = () =>
  React.useContext(BuyingSessionSidebarContext)
